import { Header } from 'rsuite';
import styled from 'styled-components';

export const HeaderStyled = styled(Header)`
  height: 140px;
  border-bottom: 1px solid #DBDBDB;
  border-top: 1px solid #DBDBDB;
`;
